import '../../app.es6';
import angular from 'angular';

class EulaController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location, $window,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = false;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.$window = $window;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();
    this.eulaChecked = false;
    this.eulaCheck = function () {
      this.eulaChecked = !this.eulaChecked;
    };
    Page.setTitle(this.Const.TITLE.eula);

    if (localStorage.getItem(Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER) {
      this.back();
    }

    EulaController.$inject = [
      '$scope', '$sessionStorage', '$location', '$window',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  agree () {
    if (this.eulaChecked) {
      let memberMeParams = { data: { eulaAgree: this.Const.EULA_AGREE_TYPE.agreed } };
      this.commonApiFactory.putMembersMe(memberMeParams).then((member) => {
        this.$sessionStorage[this.Const.SSAPP_EULA_AGREE] = member.data.eulaAgree;
        this.$location.path('/member');
        this.$scope.$apply();
      })
      .catch((error) => {
        console.log('error : ', error);
        this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
      });
    }
  }

  back () {
    this.$window.history.back();
  }
}

angular.module('myApp').controller('EulaController', EulaController);



// WEBPACK FOOTER //
// ./app/components/eula/eula-controller.es6